import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import IntlMessages from '@src/util/IntlMessages';

import { COLORS_PALETTE, DASHBOARDS_FORMS } from '../../../constants';
import { renderCountChartContent } from '../renderers/countChartRenderer';
import { transformCountChartData } from '../transformers/countChartTransformer';

import { AUX_FIELDS_BY_SECOND_DIMENSION } from './constants';
import type { WidgetConfig } from './types';

export const countChartConfig: WidgetConfig = {
  collectionName: FSCollections.COUNT_CHARTS,
  componentType: DASHBOARDS_FORMS.EVENT_COUNTER_BY_TIME,
  op: API_OPERATIONS.HISTOGRAM_BY_EVENTS,

  buildParams: (queryParams, commonParams) => {
    const { secondDimension, formId, eventTypes } = queryParams;
    const secondDimensionAux = AUX_FIELDS_BY_SECOND_DIMENSION[secondDimension as string];
    return {
      ...commonParams,
      eventTypes,
      formId,
      secondDimension,
      secondDimensionFields: secondDimensionAux?.values || [],
    };
  },

  transformData: transformCountChartData,
  renderContent: renderCountChartContent,

  onDataChange: (data, additionalState, setAdditionalState) => {
    if (
      data &&
      (data as { dimensionKeys?: unknown[] }).dimensionKeys?.length > 0 &&
      Object.values(additionalState.barColors || {}).length === 0
    ) {
      const dimensionKeys = (data as { dimensionKeys: { key: string }[] }).dimensionKeys;
      const colors = dimensionKeys.reduce<Record<string, string>>((acc, val, idx) => {
        acc[val.key] = COLORS_PALETTE[idx % COLORS_PALETTE.length];
        return acc;
      }, {});
      setAdditionalState({ barColors: colors });
    }
  },

  getSubTitle: ({ data }) => {
    if (!data) return null;
    return (
      <IntlMessages
        id="dashboards.chart.totalEvents"
        values={{ total: data.info?.totalEvents || 0 }}
      />
    );
  },
};
